import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map, of } from 'rxjs';

import { EffectsBase } from '@ps/core-data-access';
import { AuthSelectorsFacade } from '@ps/auth-data-access';
import { ToastService } from '@ps/core-overlay';
import { SurveyService } from '@ps/survey-data-access';

import {
  SurveyCreationAudienceActions,
  SurveyCreationAudienceApiActions,
} from './survey-creation-audience.actions';

@Injectable()
export class SurveyCreationTemplateEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _surveyService = inject(SurveyService);
  private readonly _authSelectors = inject(AuthSelectorsFacade);
  private readonly _toastService = inject(ToastService);

  public readonly createSurveyFromTemplate$ = createEffect(() =>
    this._actions$.pipe(
      ofType(SurveyCreationAudienceActions.createSurveyFromTemplate),
      exhaustMap(({ templateId, deleteSurveyId }) =>
        this._surveyService
          .createSurveyFromTemplate(
            templateId,
            this._authSelectors.user().unwrap().id,
            this._authSelectors.activeCompanyId(),
          )
          .pipe(
            map((survey) => {
              this._toastService.success('Survey created from template', {
                keepOpen: false,
              });
              return SurveyCreationAudienceApiActions.createSurveyFromTemplateSuccess(
                {
                  survey,
                  replacedSurveyId: deleteSurveyId,
                },
              );
            }),
            this.psCatchError(
              (error) =>
                of(
                  SurveyCreationAudienceApiActions.createSurveyFromTemplateFailure(
                    {
                      error: error.message,
                    },
                  ),
                ),
              { notify: true },
            ),
          ),
      ),
    ),
  );
}
